import { render, staticRenderFns } from "./ConfirmRegistrationView.vue?vue&type=template&id=1956c630"
import script from "./ConfirmRegistrationView.vue?vue&type=script&lang=js"
export * from "./ConfirmRegistrationView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports